import React, { useState } from 'react';
import { MessageCircle, X } from 'lucide-react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';

const ContactButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  const phoneNumber = '6615532186';
  const whatsappUrl = `https://wa.me/1${phoneNumber}?text=${encodeURIComponent('Hi, I have a question about PRSVR products')}`;
  const smsUrl = `sms:+1${phoneNumber}?body=${encodeURIComponent('Hi, I have a question about PRSVR products')}`;

  return (
    <>
      {/* Floating Button */}
      <div className="fixed bottom-8 right-8 z-50">
        {!isOpen ? (
          <Button
            onClick={() => setIsOpen(true)}
            className="h-16 w-16 rounded-full bg-warmSage hover:bg-warmSage/90 shadow-2xl hover:scale-110 transition-all duration-300 animate-pulse-slow"
            style={{
              animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite'
            }}
          >
            <MessageCircle className="h-8 w-8 text-charcoal" />
          </Button>
        ) : (
          <Card className="w-72 shadow-2xl border-2 border-warmSage animate-fadeIn">
            <CardContent className="p-6">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg font-bold text-charcoal">Contact Us</h3>
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => setIsOpen(false)}
                  className="h-8 w-8 p-0"
                >
                  <X className="h-5 w-5" />
                </Button>
              </div>
              <p className="text-sm text-warmGray mb-4">
                Have questions about our products? Choose how you'd like to reach us:
              </p>
              <div className="space-y-3">
                <Button
                  onClick={() => window.open(whatsappUrl, '_blank')}
                  className="w-full bg-green-600 hover:bg-green-700 text-white font-bold"
                >
                  <MessageCircle className="mr-2 h-5 w-5" />
                  WhatsApp
                </Button>
                <Button
                  onClick={() => window.location.href = smsUrl}
                  className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold"
                >
                  <MessageCircle className="mr-2 h-5 w-5" />
                  Text Message
                </Button>
              </div>
            </CardContent>
          </Card>
        )}
      </div>

      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: scale(0.95);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }
        
        @keyframes pulse {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.8;
          }
        }
        
        .animate-fadeIn {
          animation: fadeIn 0.2s ease-out;
        }
        
        .animate-pulse-slow {
          animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
        }
      `}</style>
    </>
  );
};

export default ContactButton;
